const admin = [
  {
    title: 'Admin Portal',
    icon: 'UsersIcon',
    enableFeature: true,
    children: [
      {
        title: 'Billing',
        route: 'billing',
        enableFeature: true,
      },
      {
        title: 'Institutions',
        route: 'institutions',
        enableFeature: true,
      },
      {
        title: 'User Management',
        route: 'user-management',
        hasPermission: 'VIEW_USER',
        enableFeature: true,
      },
      {
        title: 'User Roles',
        route: 'user-roles',
        hasPermission: 'VIEW_USER_ROLE',
        enableFeature: true,
      },
      {
        title: 'System Access',
        route: 'system-access',
        hasPermission: 'VIEW_SYSTEM_ACCESS',
        enableFeature: true,
      },
      {
        title: 'Custom Fields',
        route: 'custom-fields',
        hasPermission: 'VIEW_CUSTOM_FIELD',
        enableFeature: process.env.VUE_APP_ENABLE_FEATURE_PREVIEW,
      },
      {
        title: 'Database Size Tracker',
        route: 'database-size-tracker',
        hasPermission: 'DATA_HANDLING_REPORT',
        enableFeature: true,
      },
      {
        title: 'Subscription',
        enableFeature: true,
        children: [
          {
            title: 'Configuration',
            route: 'view-configuration',
            hasPermission: 'VIEW_SUBSCRIPTION_CONFIG',
            enableFeature: true,
          },
          {
            title: 'Invoice',
            route: 'view-invoice',
            hasPermission: 'VIEW_SUBSCRIPTION_INVOICE',
            enableFeature: true,
          },
          {
            title: 'Payment History',
            route: 'view-payment-history',
            hasPermission: 'VIEW_SUBSCRIPTION_HISTORY',
            enableFeature: true,
          },
        ],
      },
    ],
  },
]

export default admin
